import React from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { IRequest } from "../models";
import { ApprovalStatus } from "../../../../../components";
import { Button } from "antd";
import { FontFa } from "../../../../../components";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../../AppRoutes";
import { useSelector } from "../../../../../store/store";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import { useGetMyApprovals } from "../hooks";
import { Skeleton } from "antd";
import { getStatus } from "../../../human-organization/summary-employee-request/utils/get-status";
import { exportWarehouseDocx } from "../export/template";
import * as docx from "docx";
import { saveAs } from "file-saver";


export const MyApprovals: React.FC = () => {
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const columns: ColumnsType<IRequest> = [
    {
      title: "Mã yêu cầu",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render(value, record, index) {
        return getDDMMYYYFormat(record?.createdDateTime);
      },
    },
    {
      title: "Người tạo",
      dataIndex: "createdBy",
      key: "createdBy",
      render(value, record, index) {
        return record?.createdBy?.user?.displayName;
      },
    },
    {
      title: "Yêu cầu",
      dataIndex: "type",
      key: "type",
      render(value, record, index) {
        return <span className="flag warning">Xuất kho</span>;
      },
    },
    {
      title: "Đề nghị xuất kho",
      dataIndex: "eMaterialTypeExport",
      key: "eMaterialTypeExport",
      render(value, record, index) {
        return record?.fields?.eTypeExportWarehouse;
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      render(value, record, index) {

        const status = getStatus({
          currentUser: currentUserName,
          requestStatus: record.fields.eRequestStatus,
          steps: [
            {
              status: record.fields.eApprovedStatus,
              approver: record.fields.eApprovedBy,
            },
            {
              status: record.fields.eApprovedByITLeadStatus,
              approver: record.fields.eApprovedByITLead,
            }
          ],
        });

        return <ApprovalStatus status={status} />;
      },
    },
    {
      title: "",
      dataIndex: "Download",
      key: "Download",
      render(value, record, index) {
        return (
          <Button
          onClick={(e) => {
            e.stopPropagation();
            
            const doc6 = exportWarehouseDocx(record);
  
              docx.Packer.toBlob(doc6).then((blob) => {
                saveAs(
                  blob,
                  `Đề nghị xuất kho - ${getDDMMYYYFormat(new Date())}.docx`
                );
              });
          }}
          >
            <FontFa name="faPrint" size={"xs"} />
          </Button>
        );
      },
    },
  ];

  const { data, isLoading } = useGetMyApprovals();

  return (
    <>
      {!isLoading && (
        <Table
          columns={columns}
          dataSource={data}
          rowClassName="cursor-pointer"
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                history.push(
                  Routes.exportWarehouseDetail.path.replace(":id", record.id)
                );
              },
            };
          }}
        />
      )}
      {isLoading && <Skeleton />}
    </>
  );
};
